import script from "./HomeMagazineSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeMagazineSection.vue?vue&type=script&setup=true&lang=js"

import "./HomeMagazineSection.vue?vue&type=style&index=0&id=59900f20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59900f20"]])

export default __exports__